<div class="skillsheet" *ngIf="file?.total_working_months">

  <p class="mb-2">スキルシート解析（β版）による結果です</p>

  <div class="tab">
    <span class="tab-cell pr-3">経験年数：{{monthsToYears(file.total_working_months)}}年</span>
    <span class="tab-cell pr-3">案件数：{{file.experienced_projects}}件</span>
    <span class="tab-cell pr-3">案件の平均月数：{{file.average_working_months}}ヵ月</span>
    <span class="tab-cell pr-3">累計休職期間：{{file.total_blank_months}}ヵ月</span>
  </div>
  <span *ngFor="let keyword of sorted_skill_list">
    <span [ngClass]="{'highlight':isMatchedKeyword(keyword[0])}">
      <span [innerHTML] = "this.stringService.zenkakuToHankaku(keyword[0])
      | highlightSearchedKeyword: searchParams"></span>
      :<span>{{monthsToYears(keyword[1])}}年</span>
    </span>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>
</div>
